export interface TeamMember {
  name: string;
  title: string;
  credentials: string;
  image: string;
  photo: string;
}

export const teamMembers: TeamMember[] = [
  {
    name: 'Adeline Tracz',
    title: 'CEO · Innovation Leader',
    credentials: 'Healthcare AI integration at Landspítali',
    image: '/team-illustrations/adeline.png',
    photo: '/team-photos/adeline.jpg',
  },
  {
    name: 'Arnar Þór Guðjónsson',
    title: 'MD · Head of ENT Surgery',
    credentials: 'Clinical expertise in hospital workflows',
    image: '/team-illustrations/arnar.png',
    photo: '/team-photos/arnar.jpg',
  },
  {
    name: 'Hafsteinn Einarsson',
    title: 'PhD · Associate Professor, CS',
    credentials: 'Applied AI · ETH Zürich alumnus',
    image: '/team-illustrations/hafsteinn.png',
    photo: '/team-photos/hafsteinn.jpg',
  },
  {
    name: 'Haraldur Orri Hauksson',
    title: 'M.Sc. · Software Engineer',
    credentials: 'Scalable systems · ETH Zürich',
    image: '/team-illustrations/haraldur.png',
    photo: '/team-photos/haraldur.jpg',
  },
];
